var _style, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path7, _ellipse7, _g, _g2, _path8, _path9, _polygon, _line, _line2, _line3, _line4, _g3, _line5, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 529.1 300.8",
    style: {
      enableBackground: "new 0 0 529.1 300.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8A8A9C;stroke:#231F20;stroke-miterlimit:10;}\n\t.st1{fill:#35324A;stroke:#231F20;stroke-miterlimit:10;}\n\t.st2{fill:#B8B6A8;stroke:#231F20;stroke-miterlimit:10;}\n\t.st3{fill:#FBC2AB;stroke:#231F20;stroke-miterlimit:10;}\n\t.st4{fill:#7CB0DF;stroke:#231F20;stroke-miterlimit:10;}\n\t.st5{fill:#824F3B;stroke:#231F20;stroke-miterlimit:10;}\n\t.st6{fill:#B8B8CC;stroke:#231F20;stroke-miterlimit:10;}\n\t.st7{fill:#DB9C77;stroke:#231F20;stroke-miterlimit:10;}\n\t.st8{fill:#882245;stroke:#231F20;stroke-miterlimit:10;}\n\t.st9{fill:#F8B3B7;stroke:#231F20;stroke-miterlimit:10;}\n\t.st10{fill:#492979;stroke:#231F20;stroke-miterlimit:10;}\n\t.st11{fill:#FFCE07;stroke:#231F20;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;stroke:#231F20;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:#FFE6D4;}\n\t.st15{fill:#E1EEFA;}\n\t.st16{fill:#AED2F3;}\n\t.st17{fill:#231F20;stroke:#231F20;stroke-miterlimit:10;}\n\t.st18{fill:#7800C6;stroke:#231F20;stroke-miterlimit:10;}\n\t.st19{fill:#47007F;stroke:#231F20;stroke-miterlimit:10;}\n\t.st20{fill:#0EA073;stroke:#231F20;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#231F20;stroke-miterlimit:10;}\n\t.st22{fill:#47007F;}\n\t.st23{fill:#8F0CF4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.1,296.9c0,0-32.6-36.4-30.3-86.6c2.3-50.2,32.2-67.4,45.2-111.9s-8-78.4-42.1-89.7 c-32.6-10.7-56.3,7.7-62.5,22.6c-6.1,14.9-3.4,37.9,17.2,44.8c20.7,6.9,27.2-4.6,36,7.7s0.8,35.6-7.3,52.5s-32.6,87,4.2,144.5 c5.2,8.1,10,16.1,10,16.1H367.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.1,296.9c0,0-18.8-35.6-11.1-62.8c7.7-27.2,34.5-32.2,34.5-32.2s8.4,24.5,32.6,19.2 c15-3.3,28.7-18.4,21.5-42.1c-7.6-24.9-50.6-42.9-87.4-14.2c-26.7,20.9-28,46.4-27.2,68.2s16.9,64,16.9,64H380.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.6,296.9c0,0,2.3-24.1-18-34.1s-67.8-0.8-110.4-26.8s-36.8-74-24.1-92.7c16.4-24.3,45.6-33,64.8-17.2 s7.7,44.1,1.5,48.7c-6.1,4.6-13.8,7.3-13.8,7.3s-4.2,10,12.6,23.4s67.4,21.8,88.5,40.2s16.9,51.3,16.9,51.3H237.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M218,296.9c0,0-1.5-18.8-11.5-25.7s-18.4,0.8-18.4,0.8s-0.7,21.1-24.9,19.9c-25.1-1.2-25.3-27.8-18.4-39.5 c7.3-12.3,23-26.8,60.5-13c37.6,13.8,32.2,57.5,32.2,57.5H218z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M209.2,89.6c13.8-6.1,28.9-23.3,16.1-49.8c-10.7-22.2-48.4-25.1-72-10.3c-20.3,12.6-34.9,35.3-38.7,66.3 c-5.5,44.8,17.6,82.8,32.6,98.1s9.2,8,49,23.4s52.9,34.1,56.7,50.6c3.8,16.5,2.7,29.1,2.7,29.1h16.5c0,0,3.2-29.8-6.5-48.3 c-21.1-40.2-74.7-48.7-85.1-79.3c-11.1-33-12-57.2-3.2-71S209.2,89.6,209.2,89.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M75.7,180.1c0,0-27.2-11.8-52.8,8.2s-19,57.5,0.4,65.9c21.7,9.4,42.8-4,41.5-6.6c0,0-7.2-10.2,5.1-18.4 s39.2,6.9,39.2,6.9s-14.7-9-23.9-23.8C75.4,196.2,75.7,180.1,75.7,180.1z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 416.1,
    cy: 96.3,
    rx: 27.3,
    ry: 25.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 460.1,
    cy: 245.8,
    rx: 21.1,
    ry: 19.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 76.4,
    cy: 71.8,
    rx: 27.3,
    ry: 27.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 47.8,
    cy: 131.8,
    rx: 11.4,
    ry: 11.4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 406.9,
    cy: 40.8,
    rx: 10.2,
    ry: 9.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 251.3,
    cy: 18.8,
    rx: 6,
    ry: 5.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M286.2,224.1c12.3-8.8,16.4-21.3,19.2-30.2c2.9-9,4.1-18.7,3.6-28.6s-2.9-20.1-7.2-29.9 c-4.3-9.8-10.2-18.4-17.1-25.6S269.8,97,261.2,93.1c-8.5-3.9-17.6-6.2-26.8-6.5c-9.1-0.3-18.3,1.4-27,5.2l-17.4,7.4 c-8.7,3.8-18.3,12.7-24.3,19.6s-10.5,15.1-13.4,24.1c-2.9,9-4.1,18.7-3.6,28.6c0.5,9.9,2.9,20.1,7.2,29.9s10.2,18.4,17.1,25.6 s14.9,12.8,23.5,16.7c8.5,3.9,17.6,6.2,26.8,6.5c9.1,0.3,18.3-1.4,27-5.2c8.7-3.8,17.4-9.4,24.7-13.9 C281.1,227.3,286.2,224.1,286.2,224.1z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9157 -0.4019 0.4019 0.9157 -51.3258 102.745)",
    className: "st12",
    cx: 219.2,
    cy: 173.7,
    rx: 61.3,
    ry: 69.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M233.8,236c-38.7-15.6-66-53.1-66-96.9c0,0,0-0.1,0-0.1c-8.6,16.5-9.5,37.8-0.8,57.6 C179.5,225,207.7,240.9,233.8,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M233.8,236c3.8-0.7,7.6-1.8,11.2-3.4c7.4-3.2,13.7-8.1,18.7-14c-40-4.9-71.1-38.6-71.1-79.4 c0-9,1.5-17.7,4.3-25.8c-1.2,0.4-2.4,0.9-3.6,1.4c-11.3,5-20,13.6-25.5,24.3c0,0,0,0.1,0,0.1C167.8,183,195.1,220.5,233.8,236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M263.7,218.6c5.9-7,10-15.4,12.1-24.6c-0.7,0-1.4,0.1-2.1,0.1c-30.7,0-55.5-24.6-55.5-54.9 c0-10,2.7-19.3,7.4-27.4c-9.5-2.1-19.3-1.7-28.6,1.6c-2.8,8.1-4.3,16.8-4.3,25.8C192.6,180,223.7,213.7,263.7,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M273.7,194c0.7,0,1.4,0,2.1-0.1c3.1-13.6,1.9-28.8-4.4-43.2c-9.1-20.8-26.7-34.9-45.8-39 c-4.7,8.1-7.4,17.4-7.4,27.4C218.2,169.4,243,194,273.7,194z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8898 -0.4564 0.4564 0.8898 -61.4213 116.8286)",
    className: "st17",
    cx: 211.1,
    cy: 185.6,
    rx: 29.5,
    ry: 36.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8898 -0.4564 0.4564 0.8898 -61.2265 110.7244)",
    className: "st12",
    cx: 198.6,
    cy: 182.1,
    rx: 8,
    ry: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.894 -0.4481 0.4481 0.894 -69.0751 122.3175)",
    className: "st12",
    cx: 224,
    cy: 207.1,
    rx: 3.9,
    ry: 4.9
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M282,243.2c-7.4,4.1-14,11-17.1,14.5c-1.1,1.3-1.3,3.2-0.4,4.7l6.5,10.8c0.9,1.5,2.8,2.3,4.5,1.8l1.2-0.3 l20.8-5.7c0.7-0.2,1.4-0.6,1.9-1.1l12.8-13.6c1.3-1.3,1.5-3.4,0.5-4.9l-6.6-10.3c-1-1.5-2.8-2.2-4.5-1.7L282,243.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M262.9,238.7l8.8,16.5c0,0,4.6,0.8,14.2-4.6c9.6-5.4,10.3-10,10.3-10l-9.6-16.1L262.9,238.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "288,296.9 275.1,274.7 298.7,268.8 311.3,255.6 337.4,296.9 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 312.9,
    y1: 258,
    x2: 298.7,
    y2: 296.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 291.2,
    y1: 271.3,
    x2: 284.7,
    y2: 290.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 322.3,
    y1: 274.3,
    x2: 313.8,
    y2: 296.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 331.6,
    y1: 287.7,
    x2: 328.4,
    y2: 296.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M105.9,246.7c-7.6-4.1-0.8-19.1,9.4-23.7c10.8-4.9,26.4-0.5,30.5,10.5c4,11.1,0.5,17.3-6.5,24 c-7,6.7-7.5,8.2-7.5,12.1c0,5.9-3.2,9.4-8.6,9.4c-8.7,0-12.7-11.1-4-21c8.6-10,15.1-14.3,12.1-21.6s-12.4-3.5-12.1,1.1 S112.9,250.4,105.9,246.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 124,
    cy: 289,
    r: 7.8
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 4.6,
    y1: 296.9,
    x2: 526.7,
    y2: 296.9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 43.9,
    cy: 236.3,
    r: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 42.9,
    cy: 243.5,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 44.5,
    cy: 241.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 40.7,
    cy: 247.6,
    r: 0.6
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 206.3,
    cy: 64.7,
    r: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 202.8,
    cy: 71.3,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 204.4,
    cy: 69.2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 200.7,
    cy: 75.4,
    r: 0.6
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 363.2,
    cy: 54.9,
    r: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 357.1,
    cy: 60,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 358.7,
    cy: 57.9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 355,
    cy: 64.1,
    r: 0.6
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 404,
    cy: 104.5,
    r: 8.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 400.6,
    cy: 106.9,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 401.5,
    cy: 105.9,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 399.3,
    cy: 109,
    r: 0.3
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 451.1,
    cy: 248.2,
    r: 8.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 447.9,
    cy: 248.2,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 448.8,
    cy: 247.2,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 446.6,
    cy: 250.3,
    r: 0.3
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 387.1,
    cy: 181.7,
    r: 12.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 383,
    cy: 184.1,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 384.3,
    cy: 182.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 381.2,
    cy: 187,
    r: 0.5
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 99.6,
    cy: 177.5,
    r: 16.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 101.1,
    cy: 184.1,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 102.7,
    cy: 182,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 99,
    cy: 188.2,
    r: 0.6
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 165.9,
    cy: 267.6,
    r: 8.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 162.8,
    cy: 265.9,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 163.6,
    cy: 264.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 161.6,
    cy: 268.1,
    r: 0.3
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 82.6,
    cy: 83.2,
    r: 9.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 84,
    cy: 87.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 85,
    cy: 85.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 82.8,
    cy: 89.5,
    r: 0.4
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 49.4,
    cy: 134.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 50.4,
    cy: 137.1,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 51,
    cy: 136.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 49.6,
    cy: 138.7,
    r: 0.2
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M294.8,263.9l-3.9-7.1c-0.6-1.2-2-1.7-3.2-1.4l-18,4.5c-1.9,0.5-2.8,2.6-1.8,4.3l4.1,7 c0.6,1.1,1.9,1.6,3.2,1.3l17.8-4.3C294.8,267.6,295.7,265.5,294.8,263.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M293.8,251.7l8.2-9.6c0.9-1.1,2.6-1,3.4,0.2l5.2,8.1c0.5,0.8,0.4,1.9-0.2,2.6l-9.1,9.4c-1,1.1-2.8,0.8-3.4-0.5 l-4.4-7.9C293.1,253.2,293.2,252.3,293.8,251.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNotFound);
export default __webpack_public_path__ + "static/media/file_not_found.f10a96d5999c53d4abebd7c8d34b1e85.svg";
export { ForwardRef as ReactComponent };